<script src="node_modules/jquery/dist/jquery.min.js"></script>

<script src="https://cdn.jsdelivr.net/gh/emn178/chartjs-plugin-labels/src/chartjs-plugin-labels.js"></script>
<script src="https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.9.3/Chart.min.js"></script>



<div class="col-12 mt-5">
    <div class="row w-100">
    <div class="col-md-8 m-0 p-0">
      
            <div class="d-flex justify-content-between   w-100 m-0">
                <div class="col-sm-3  ">
                    <div class="row border p-1 m-1 border-black   " style="background:rgba(213, 224, 255); border-radius: 7%;">
                      
            
                        <div class="d-flex justify-content-between p-0 w-100" >
            
                            <div class="d-flex   mb-0  p-2 "
                                style="font-size:12px; font-family:Trebuchet MS; font-weight: bolder;" translate>
                                Total<br/> Appointments </div>

                                <i class="col-md-3 fa fa-calendar-alt fa-1x  p-2" ></i>

                        </div>
                            <div id="appointmentSlide" class="carousel slide  vertical d-flex " data-ride="carousel"   >
                                <div class="carousel-inner  vertical" >
                                    <div class="carousel-item active  vertical" style="max-height: 50px" data-interval="2000">
                                        <a class=" "
                                            style="float:start; font-size:25px; font-weight: bolder; font-family:monospace;  "><p>{{totalappointmentsquare}}</p></a>
                                    </div>
                                  
                                </div>
            
                                <!-- Left and right controls -->
                                <!-- <a class="carousel-control-prev" href="#assetSlide" data-slide="prev">
            <span class="carousel-control-prev-icon"></span>
            </a>
            <a class="carousel-control-next" href="#assetSlide" data-slide="next">
            <span class="carousel-control-next-icon"></span>
            </a>-->
                            </div>
            
                    </div>
            
            
                    
                    <a class="carousel-control-prev" href="#appointmentSlide" data-slide="prev" hidden>
                        <span class="carousel-control-prev-icon"></span>
                    </a>
                    <a class="carousel-control-next" href="#appointmentSlide" data-slide="next" hidden>
                        <span class="carousel-control-next-icon"></span>
                    </a>
                </div>
            <!---------------------------------------------------------------------------------------------------------------------------------------------------------------------------->
            
            
                <div class="col-sm-3 ">
                    <div class="row border p-1 m-1  border-black  " style="background:rgba(213, 224, 255); border-radius: 7%;">
                     
            
                        <div id="trioSlide1" class="carousel slide vertical 0 " data-ride="carousel"   >
                            <div class="carousel-inner vertical "  >
                                <div class="carousel-item active  vertical  "  style="max-height: 175px" data-interval="2000" >
                        <div class="d-flex justify-content-between p-0 w-100">
                            <div class="d-flex   mb-0  p-2 "
                            style="font-size: 12px; font-family:Trebuchet MS; font-weight: bolder; " translate>
                                8899 Jane St Appointments</div>

                           <i class="col-md-3 fa fa-store-alt fa-1x p-2" ></i>

                            </div>

                         
            
                                    
                                   
                 <a class=" "
                        style="float:start; font-size: 25px; font-family:monospace; font-weight: bolder; ">
                              <p>{{janerequesttypeforbranchsquare}}</p>
                        </a>
            
                                      
                                    </div>
            
                                    <div class="carousel-item  vertical  "  style="max-height: 175px" data-interval="2000" >
                                        <div class="d-flex justify-content-between p-0 w-100">
                                            <div class="d-flex   mb-0  p-2 "
                                            style="font-size: 12px; font-family:Trebuchet MS; font-weight: bolder; " translate>
                                                1020 Lawrence St Appointments</div>
                
                                                <i class="col-md-3 fa fa-store-alt fa-1x p-2" ></i>
                
                                            </div>
                
                                         
                            
                                                    
                                                   
                                       <a class=" " style="float:start; font-size: 25px; font-family:monospace; font-weight: bolder; ">
                                            <p>{{lawrencerequesttypeforbranchsquare}}</p>
                                                 </a>
                            
                                                      
                                                    </div>
                                                    
                                                    
                               <div class="carousel-item   vertical  "  style="max-height: 175px" data-interval="2000" >
                                              <div class="d-flex justify-content-between p-0 w-100">
                                       <div class="d-flex   mb-0  p-2 "
                                             style="font-size: 12px; font-family:Trebuchet MS; font-weight: bolder; " translate>
                                                  3050 Vega St Appointments</div>
                                
                                                    <i class="col-md-3 fa fa-store-alt fa-1x p-2" ></i>
                                
                                              </div>
                                
                                                         
                                            
                                                                    
                                                                   
                                                               <a class=" "   style="float:start; font-size: 25px; font-family:monospace; font-weight: bolder; ">
                                                <p>{{vegarequesttypeforbranchsquare}}</p>
                                                      </a>
                                            
                                                                      
                                                                    </div>


                                                        <div class="carousel-item  vertical  "  style="max-height: 175px" data-interval="2000" >
                                                            <div class="d-flex justify-content-between p-0 w-100">
                                                                 <div class="d-flex   mb-0  p-2 "
                                                                style="font-size: 12px; font-family:Trebuchet MS; font-weight: bolder; " translate>
                                                                    9151 St Laurent Appointments</div>
                                                
                                                                 <i class="col-md-3 fa fa-store-alt fa-1x p-2" ></i>
                                                
                                                                </div>
                                                
                                                                         
                                                            
                                                                                    
                                                                                   
                                                                      <a class=" " style="float:start; font-size: 25px; font-family:monospace; font-weight: bolder; ">
                                                                          <p>{{stlaurentrequesttypeforbranchsquare}}</p>
                                                                            </a>
                                                            
                                                                                      
                                                                                    </div>                                                                    
                                </div>
                            </div>
            
                       <!--     <div id="trainingSlide1" class="carousel slide vertical d-flex " data-ride="carousel">
                                <div class="carousel-inner vertical">
                                    <div class="carousel-item active vertical">
                                        <div class="d-flex mt-3 mb-0 pt-2 p-0 "
                                            style="font-size:25px; font-family:Trebuchet MS; font-weight: bolder; color: lightgoldenrodyellow;">
                                            Training </div>
                                    </div>
                                    <div class="carousel-item vertical">
                                        <div class="d-flex mt-3 mb-0 pt-2 p-0 "
                                            style="font-size:25px; font-family:Trebuchet MS; font-weight: bolder; color: lightgoldenrodyellow;">
                                            Session </div>
                                    </div>
                                </div>
            
                            </div>-->
            
            
                            <a class="carousel-control-prev" href="#trioSlide1" data-slide="prev" hidden>
                                <span class="carousel-control-prev-icon"></span>
                            </a>
                            <a class="carousel-control-next" href="#trioSlide1" data-slide="next" hidden>
                                <span class="carousel-control-next-icon"></span>
                            </a>
                        
                    </div>
            
                </div>
            
            <!------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------->
            
                <!--   <div class="col-sm-3 ">
                    <div class="row border p-1 m-1 bg-primary border-primary rounded   ">
                   <i class="col-md-3 fa fa-users fa-5x p-2"  style="color:#003366;"></i>
                   <div class="col-sm-5 mt-5 pt-2 "  style="font-size:34px; font-family:Trebuchet MS; font-weight: bolder; color: whitesmoke;"> Employees</div>
                   <div class="col-sm-4">
                     <a class="text-lg" style="float:right; font-size: 50px;">{{employees.length}}</a>
                    </div>
                </div>
                </div>-->
            
            
            
            
                <div class="col-sm-3 ">
                    <div class="row border border-black pb-1 m-1 w-100 "  style="background:rgba(213, 224, 255); border-radius: 7%;">
                        
                            
                      
            
                            <div id="employeeSlide" class="carousel slide vertical  w-100 " data-ride="carousel"   >
                                <div class="carousel-inner vertical" >
                                    <div class="carousel-item active vertical p-2"  style="max-height: 150px"  data-interval="3000" >
                                      
                                        <div class="d-flex justify-content-between p-0 w-100">
                                            <div class="d-flex   mb-0  p-1 "
                                            style="font-size:12px; font-family:Trebuchet MS; font-weight: bolder; " translate>
                                                Popular<br/> Client</div>
                                        
                                        <i class="col-md-3 fa fa-trophy fa-1x p-2" ></i>
                            
                            </div>


                                        <div class="d-flex p-0 m-1 w-100">


                                            <a class=" p-0 m-0 "
                                            style="float:start;color: #000000; font-size:25px; font-family:monospace;font-weight: bolder;  ">{{populardescribesyousquarevalue}}</a>
                                        


                                        <a class="w-100 p-0 m-0"
                                            style="text-align:end; color: #000000; float: end; font-size:10px; font-family:monospace; font-weight: bolder; ">
                                            <p>{{populardescribesyousquarekey}}</p></a>
            
                                        </div>
            
                                            
                                    </div>
                                    <div class="carousel-item vertical  p-1" style="max-height: 150px" data-interval="2000" >
                
                                        <div class="d-flex justify-content-between p-0 w-100">
                                            <div class="d-flex   mb-0  p-2 "
                                            style="font-size:12px; font-family:Trebuchet MS; font-weight: bolder; " translate>
                                                Popular<br/> Product</div>
                                                <i class="col-md-3 fa fa-trophy fa-1x p-2" ></i>
                                                </div>
                                                

                                        <div class="d-flex p-0 m-1">
                                          
                
                                                <a class=" p-0 m-0 "
                                                style="float:start; color: #000000;text-align:start;font-size:25px; font-family:monospace;font-weight: bolder;  ">{{popularlookingforsquarevalue}}</a>

                                                <a class=" p-0 m-0 w-100"
                                                style="float:end; color: #000000;text-align:end;font-size:10px; font-family:monospace; font-weight: bolder; ">
                                               <p>{{popularlookingforsquarekey}}</p></a>
                
                                            </div>
                                    </div>
                                </div>
                            </div>
            
            
                            <a class="carousel-control-prev" href="#employeeSlide" data-slide="prev" hidden>
                                <span class="carousel-control-prev-icon"></span>
                            </a>
                            <a class="carousel-control-next" href="#employeeSlide" data-slide="next" hidden>
                                <span class="carousel-control-next-icon"></span>
                            </a>
            
                       
                    </div>
            
                </div>
            
            <!--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------->            
                <div class="col-sm-3 ">
                    <div class="row border p-1 m-1  border-black"  style="background:rgb(213, 224, 255); border-radius: 7%;" >
                      
                      
                        <div class="d-flex justify-content-between p-0 w-100" >
            
                            <div class="d-flex   mb-0  p-2 "
                                style="font-size:12px; font-family:Trebuchet MS; font-weight: bolder; " translate>
                            Sales<br> Representative</div>
                            <i class="col-md-3 fa fa-user-tie fa-1x p-2" ></i>

                            </div>

                            <div id="appointmentSlide" class="carousel slide  vertical d-flex " data-ride="carousel"   >
                                <div class="carousel-inner  vertical" >
                                    <div class="carousel-item active  vertical" style="max-height: 40px" data-interval="2000">
                             <a class=" float-right"
                                            style="float:right;color: #000000; text-align:right;font-size:25px; font-weight: bolder; font-family:monospace;  "><p>{{totalsalesrepsquare}}</p></a>
                            <!-- <a class="d-flex bg-warning" style="float:right; font-size: 25px;">${{valueamount}}</a></div>-->
                        </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            
            
            
            <!--************************************************************************************************************************************************************************************************-->          

            <div class="col-md-12 mt-3 "   >

            


<div class="col-md-12  "   >

    <h6 class="table-heading rounded text-white text-center p-3 bg-dark"  ><strong translate>Appointments Per Month</strong>   </h6>
    <div class="row w-100 d-flex ">

        <div class="col-md-6   chart-container  box box-primary rounded border-top border-primary shadow-sm bg-white p-3  " >

            <canvas class="col-md-5" id="JaneChart" style="max-width:100%; min-width: 100%;" ></canvas>
        </div>

        
   <div class="col-md-6   chart-container  box box-primary rounded border-top border-primary shadow-sm bg-white p-3  "  >

   <canvas class="col-md-5" id="VegaChart" style="max-width:100%; min-width: 100%;" ></canvas>
</div>


</div>
<div class="row w-100 d-flex ">
 <div class="col-md-6   chart-container  box box-primary rounded border-top border-primary shadow-sm bg-white p-3  " >

    <canvas class="col-md-5" id="LawrenceChart" style="max-width:100%; min-width: 100%;" ></canvas>
 </div>


 <div class="col-md-6   chart-container  box box-primary rounded border-top border-primary shadow-sm bg-white p-3  " >

    <canvas class="col-md-5" id="StLaurentChart" style="max-width:100%; min-width: 100%;" ></canvas>
 </div>

 <!--<div class="col-md-12 h  mt-5 chart-container  box box-primary rounded border-top border-primary shadow-sm bg-white p-3  " >

    <canvas class="col-md-5" id="StLaurentChart" style="max-width:100%; min-width: 100%; height: 140%;" ></canvas>
 </div>-->


 </div>
</div>




            </div>
    </div>


    <div class="col-md-4 p-0 h-100">

        <div class="col-md-12 d-flex p-0 "   >
            <div class=" col-md-12  mt-2 box box-primary rounded border-top border-primary shadow-sm bg-white p-1  pb-5"style="min-width: 28%; "  >
                  <div id="salesrepSlide" class="carousel slide " data-ride="carousel" >
          
                      <!-- Indicators -->
                      <ul class="carousel-indicators">
                          <li data-target="#salesrepSlide" data-slide-to="0" class="active"></li>
                          <li data-target="#salesrepSlide" data-slide-to="1"></li>
                          <li data-target="#salesrepSlide" data-slide-to="2"></li>
                      </ul>
          
                      <!-- The slideshow -->
                      <div class="carousel-inner">
                          <div class="carousel-item active">
                              <div class=" border p-1 m-1 rounded   " >
                                  <h6 class="table-heading rounded text-white text-center p-3 bg-dark"  ><strong translate>Sales Representative Appointments</strong>   <div class="p-1 mr-3">
                                 <!--<input class=" p-2 m-2 w-100 mx-2 text-center rounded "  type="text" placeholder="Search"  [(ngModel)]="searchText"
                             aria-label="Search" >-->
                           </div></h6>
                                  
                          <div  style="overflow:auto; overflow-y: scroll; z-index: none; max-height: 515px;"  >
                              <table class="table w-100 table-striped text-center"  style="font-size: 12px; max-height: 400px;">
                                          
                                 
                                  <th class="text-center p-2" style=" font-family:'DINPro'" translate>Full Name</th>
          
                                  <th class="text-center p-2" style=" font-family:'DINPro'" translate>Count</th>
                                  <th class="text-center p-2" style=" font-family:'DINPro'" translate>Location</th>
                                 
                                <tbody>
                                 
                                  <tr   *ngFor='let list of allsalesrepapt ' style=" font-family:'DINPro'">
                                      <td class="text-center p-2"   >{{list.salesRep}}</td>                           
                                      <td class="text-center p-2"  >{{list.count}}</td>
                                      <td class="text-center p-2"  >{{list.branch}}</td>
                                  </tr>
                                </tbody> 
                              </table>
                         </div>
                              </div>
                          </div>
          
                      
                      </div>
          
             
                  </div>
                
          </div>
          
           
          </div>
          </div>
          




    </div>
<!--************************************************************************************************************************************************************************************************-->






<!--************************************************************************************************************************************************************************************************-->
<div class="col-sm-12 d-flex w-100 m-0 p-0" [formGroup]="halfdonutForm" >
    
    <div class=" d-flex flex-column col-sm-3 box box-primary border-top border-primary shadow-sm bg-white my-3  p-0"
    style="max-width:100%; min-width: 33%; ">
    <div class="text-center p-2">
    <select (change)="switchhalfdonutlookingFormonth($event.target.value)"  formControlName="halfdonutlookingFor" style=" font-family:'DINPro'" class="form-control" >
     <option value="January">January</option>
     <option value="February">February</option>
     <option value="March">March</option>
     <option value="April">April</option>
     <option value="May">May</option>
     <option value="June">June</option>
     <option value="July">July</option>
     <option value="August">August</option>
     <option value="September">September</option>
     <option value="Octoboer">October</option>
     <option value="November">November</option>
     <option value="December">December</option>
 </select>
 </div>
    <div class="chart-container " style="height:400px" >
  
        <canvas id="productinquiryhalfdonut"></canvas>
    </div>
 
    <div class=" d-flex flex-column col-sm-3 box box-primary border-top border-primary shadow-sm bg-white my-3 p-0"
    style="max-width:100%; min-width: 32%; ">
    <div class="chart-container "  >
<canvas id="lookingForcanvas" ></canvas>
</div>



<div class=" mt-5 box box-primary rounded border-top border-primary shadow-sm bg-white p-1  pb-5"style="min-width: 28%; "  >
    <div id="productSlide" class="carousel slide " data-ride="carousel">

        <!-- Indicators -->
        <ul class="carousel-indicators">
            <li data-target="productSlide" data-slide-to="0" class="active"></li>
            <li data-target="#productSlide" data-slide-to="1"></li>
            <li data-target="#productSlide" data-slide-to="2"></li>
        </ul>

        <!-- The slideshow -->
        <div class="carousel-inner">
            <div class="carousel-item active">
                <div class=" border p-3 m-1 rounded   " >
              
                    
            <div  style="overflow:auto; overflow-y: scroll; z-index: none; max-height: 220px;"  >
                <table class="table w-100  text-center"  style="font-size: 12px; max-height: 100px;">

                          
                    <th class=" p-2 text-success" style=" font-family:'DINPro'" translate>Product</th>
                    <th class="text-center p-2 text-success" style=" font-family:'DINPro'">#</th>
                   

                    <tr   *ngFor='let list of lookingforapt | keyvalue '>
                        <td class="p-2 text-success"  style=" font-family:'DINPro'" >{{list.key}}</td>                           
                        <td class="text-center p-2 text-success" style=" font-family:'DINPro'" >{{list.value}}</td>
                    </tr>

                </table>




           </div>
                </div>
            </div>
            
        </div>

  
    </div>
  
</div>
</div> 
    
  </div>
 <!--************************************************************************************************************************************************************************************************-->
 
  <div class=" d-flex flex-column col-sm-3 box box-primary border-top border-primary shadow-sm bg-white my-3 mx-1 p-0 "
    style="max-width:100%; min-width: 33%; ">
    <div class="text-center p-2">
    <select (change)="switchhalfdonutdescribesYoumonth($event.target.value)" formControlName="halfdonutdescribesYou"style=" font-family:'DINPro'" class="form-control text-center">
     <option value="January">January</option>
     <option value="February">February</option>
     <option value="March">March</option>
     <option value="April">April</option>
     <option value="May">May</option>
     <option value="June">June</option>
     <option value="July">July</option>
     <option value="August">August</option>
     <option value="September">September</option>
     <option value="Octoboer">October</option>
     <option value="November">November</option>
     <option value="December">December</option>
 </select>
 </div>
    <div class="chart-container " style="height:400px" >
  
        <canvas id="describesyouhalfdonut"></canvas>
    </div>
 
    <div class=" d-flex flex-column col-sm-3 box box-primary border-top border-primary shadow-sm bg-white my-3 p-0 "
    style="max-width:100%; min-width: 32%; ">

    <div class="chart-container "  >
     <canvas id="describesYoucanvas" ></canvas>
     </div>


     <div class="  mt-5 box box-primary rounded border-top border-primary shadow-sm bg-white p-1  pb-5"style="min-width: 28%; "  >
         <div id="clientSlide" class="carousel slide " data-ride="carousel">
 
             <!-- Indicators -->
             <ul class="carousel-indicators">
                 <li data-target="#clientSlide" data-slide-to="0" class="active"></li>
                 <li data-target="#clientSlide" data-slide-to="1"></li>
                 <li data-target="#clientSlide" data-slide-to="2"></li>
             </ul>
 
             <!-- The slideshow -->
             <div class="carousel-inner">
                 <div class="carousel-item active">
                     <div class=" border p-3 m-1 rounded   " >
                   
                         
                 <div  style="overflow:auto; overflow-y: scroll; z-index: none; max-height: 220px;"  >
                     <table class="table w-100  text-center"  style="font-size: 12px; max-height: 100px;">
                                 
                        
                         <th class=" p-2 text-primary" style=" font-family:'DINPro'" translate>Clients</th>
                         <th class="text-center p-2 text-primary" style=" font-family:'DINPro'">#</th>
                        
                        
                        
                         <tr   *ngFor='let list of describesyouapt | keyvalue '>
                             <td class="p-2 text-primary" style=" font-family:'DINPro'"  >{{list.key}}</td>                           
                             <td class="text-center p-2 text-primary" style=" font-family:'DINPro'" >{{list.value}}</td>
                         </tr>
 
                     </table>
                </div>
                     </div>
                 </div>
                 
             </div>
 
       
         </div>
       
 </div>
    </div> 
    
  </div>
 
 <!--************************************************************************************************************************************************************************************************-->
 
  <div class=" d-flex flex-column col-sm-3 box box-primary border-top border-primary shadow-sm bg-white my-3  p-0"
  style="max-width:100%; min-width: 33%; ">
  <div class="text-center p-2">
  <select (change)="switchhalfdonutrequestTypemonth($event.target.value)" formControlName="halfdonutrequestType" style=" font-family:'DINPro'" class="form-control text-center">
   <option value="January">January</option>
   <option value="February">February</option>
   <option value="March">March</option>
   <option value="April">April</option>
   <option value="May">May</option>
   <option value="June">June</option>
   <option value="July">July</option>
   <option value="August">August</option>
   <option value="September">September</option>
   <option value="Octoboer">October</option>
   <option value="November">November</option>
   <option value="December">December</option>
 </select>
 </div>
  <div class="chart-container "  style="height:400px">
 
      <canvas id="requesttypehalfdonut"></canvas>
  </div>
 
 
  <div class=" d-flex flex-column col-sm-3 box box-primary border-top border-primary shadow-sm bg-white my-3 p-0"
           style="max-width:100%; min-width: 31%; ">
           <div class="chart-container "  >
            
            <canvas id="requestTypecanvas" ></canvas>
            
            </div>

  <div class="  mt-5 box box-primary rounded border-top border-primary shadow-sm bg-white p-1  pb-5"style="min-width: 28%; "  >
    <div id="typeSlide" class="carousel slide " data-ride="carousel">

        <!-- Indicators -->
        <ul class="carousel-indicators">
            <li data-target="#typeSlide" data-slide-to="0" class="active"></li>
            <li data-target="#typeSlide" data-slide-to="1"></li>
            <li data-target="#typeSlide" data-slide-to="2"></li>
        </ul>

        <!-- The slideshow -->
        <div class="carousel-inner">
            <div class="carousel-item active">
                <div class=" border p-3 m-1 rounded   " >
              
                    
            <div  style="overflow:auto; overflow-y: scroll; z-index: none; max-height: 220px;"  >
                <table class="table w-100  text-center"  style="font-size: 12px; max-height: 100px;">
                            
                   
                    <th class=" p-2 text-danger" style=" font-family:'DINPro'" translate>Type</th>
                    <th class="text-center p-2 text-danger" style=" font-family:'DINPro'">#</th>
                   
                   
                   
                    <tr   *ngFor='let list of requesttypeapt | keyvalue '>
                        <td class="p-2 text-danger" style=" font-family:'DINPro'"  >{{list.key}}</td>                           
                        <td class="text-center p-2 text-danger" style=" font-family:'DINPro'" >{{list.value}}</td>
                    </tr>

                </table>
           </div>
                </div>
            </div>
            
        </div>

  
    </div>
  
</div>
 </div>
 </div>
        
 
 
 
         </div>
 
 


         <div class="col-md-12 bg-muted p-0 mb-0 " style="min-height: 10%;">
            <div class=" d-flex justify-content-between row w-85 mt-2 mx-3">
            
          <div class=" col-md-12 box box-primary rounded border-top border-primary shadow-sm bg-white p-1 " style="min-width: 48%;"  >
                <div id="notificationSlide" class="carousel slide " data-ride="carousel">
        
                   
                    <ul class="carousel-indicators">
                        <li data-target="#notificationSlide" data-slide-to="0" class="active"></li>
                        <li data-target="#notificationSlide" data-slide-to="1"></li>
                        <li data-target="#notificationSlide" data-slide-to="2"></li>
                    </ul>
        
                    
                    <div class="carousel-inner" >
                        <div class="carousel-item active">
                            <div class=" border p-3 m-1 rounded   " >
                                <h6 class="table-heading rounded text-white text-center p-3" style="background-color: #035332; font-family:'DINPro'"><strong translate>Client's Interest</strong></h6>
                        <div  style="overflow:auto; height: 200px;"  >
                            <table class="table w-100 text-center"  style=" font-size: 12px;" >
                                <thead >
                                    <tr >
                                     <th  *ngFor='let table of tablelookingforarray[0] | keyvalue ' class=" p-2" style=" font-family:'DINPro'" >{{table.key}}</th>
                                 </tr>
                                 </thead>
                                 <tbody class="pt-4" style="overflow:auto;">
                                     <tr *ngFor='let tableData of tablelookingforarray '>
                                      
                                         <td *ngFor='let table of tableData | keyvalue'  >
                                            <ng-container class="font-weight-bold float-left" *ngIf="table.value=='Average' || table.value=='8899 Jane St' || table.value=='3050 Vega'  || table.value=='1020 Lawrence' || table.value=='9151 St Laurent' || table.value=='5855 Taschereau Blvd' || table.value=='1795 A Jean-Noel-Lavoie' || table.value=='5302 2nd Ave';  else elseBlock" style="font-weight: bolder;">      
                                            <div class="font-weight-bold float-left" style="font-size: 15px; font-family:'DINPro'">{{table.value}}</div>
                                        </ng-container>
                                        <ng-template #elseBlock>{{table.value}}</ng-template>
                                    </td>
                                        
                                        
                                    
                                     </tr>
                                 </tbody>
                                 </table>
                       </div>
                            </div>
                        </div>
        
                       <div class="carousel-item ">
                            <div class=" border p-3 m-1 rounded  " >
                                <h6 class="table-heading   rounded text-white bg-primary text-center p-3" style=" font-family:'DINPro'"><strong translate>Client's Category</strong></h6>
                           
                                <div  style=" height: 200px; overflow:auto;"  >
                                    <table class="table w-100 text-center"  style=" font-size: 12px; font-family:'DINPro'" >
                                   <thead >
                                       <tr >
                                        <th  *ngFor='let table of tabledescribesYouarray[0] | keyvalue ' class=" p-2" style=" font-family:'DINPro'" >{{table.key}}</th>
                                    </tr>
                                    </thead>
                                    <tbody class="pt-4" style="overflow:auto;">
                                        <tr *ngFor='let tableData of tabledescribesYouarray '>
                                            <td *ngFor='let table of tableData | keyvalue' >
                                                <ng-container class="font-weight-bold float-left" *ngIf="table.value=='Average' || table.value=='8899 Jane St' || table.value=='3050 Vega'  || table.value=='1020 Lawrence' || table.value=='9151 St Laurent' || table.value=='5855 Taschereau Blvd' || table.value=='1795 A Jean-Noel-Lavoie' || table.value=='5302 2nd Ave';  else elseBlock" style="font-weight: bolder;">      
                                                    <div class="font-weight-bold float-left" style="font-size: 15px; font-family:'DINPro'">{{table.value}}</div>
                                                </ng-container>
                                                <ng-template #elseBlock>{{table.value}}</ng-template>
                                            </td>
                                   
                                           
                                           
                                       
                                        </tr>
                                    </tbody>
                                    </table>
                                        
                                </div>
                        </div>
                        </div>
                       <div class="carousel-item " >
                            <div class=" border p-3 m-1 rounded   " >
                                <h6 class="table-heading rounded text-center text-white p-3" style="background-color:#c32525;  font-family:'DINPro'"><strong translate>Request Categories</strong></h6>
                                <div   style="overflow:auto; height: 200px;"  >
                                    <table class="table w-100 text-center"  style=" font-size: 12px;" >
                                        <thead >
                                            <tr >
                                             <th  *ngFor='let table of tablerequestTypearray[0] | keyvalue ' class=" p-2" style=" font-family:'DINPro'" >{{table.key}}</th>
                                         </tr>
                                         </thead>
                                         <tbody class="pt-4" style="overflow:auto;">
                                             <tr *ngFor='let tableData of tablerequestTypearray '>
                                                 <td *ngFor='let table of tableData | keyvalue' >
                                                    <ng-container class="font-weight-bold float-left" *ngIf="table.value=='Average' || table.value=='8899 Jane St' || table.value=='3050 Vega'  || table.value=='1020 Lawrence' || table.value=='9151 St Laurent' || table.value=='5855 Taschereau Blvd' || table.value=='1795 A Jean-Noel-Lavoie' || table.value=='5302 2nd Ave';  else elseBlock" style="font-weight: bolder;">      
                                                        <div class="font-weight-bold float-left" style="font-size: 15px; font-family:'DINPro'">{{table.value}}</div>
                                                    </ng-container>
                                                    <ng-template #elseBlock>{{table.value}}</ng-template>

                                                 </td>
                                        
                                                
                                                
                                            
                                             </tr>
                                         </tbody>
                                         </table>
                                </div>
                        </div>
                        </div>
                    </div>
        
                   
                    <a class="carousel-control-prev" href="#notificationSlide" role="button" data-slide="prev">
                        <span class="carousel-control-prev-icon"></span>
                    </a>
                    <a class="carousel-control-next" href="#notificationSlide" role="button" data-slide="next">
                        <span class="carousel-control-next-icon"></span>
                    </a>
                </div>
              
        </div>
        </div>
        </div>



        <div class="col-md-12 my-3   " >
            <div class="col-md-12  chart-container  box box-primary rounded border-top border-primary shadow-sm bg-white p-3  " style="max-width:100%; min-width: 100%; ;" >
            
                <canvas class="col-md-12" style="max-height: 500px" id="myCharta" ></canvas>
             </div>
            </div>


            
</div>
<!--************************************************************************************************************************************************************************************************-->
<!--*OLD QUOTE********************************************************************************************************************************************************************************************-->









<!--************************************************************************************************************************************************************************************************-->
<!--<div class="col-md-12 mt-5">
<div class="d-flex justify-content-between  row w-100 m-0">
    <div class="col-sm-3  ">
        <div class="row border p-1 m-1 border-black rounded    " style="background:#003b76;">
            <i class="col-md-3 fa fa-calendar-alt fa-5x  p-2" style="color:#00000060;"></i>

            <div class="col-sm-9 p-0 w-100" >

                <div id="appointmentSlide" class="carousel slide  vertical d-flex " data-ride="carousel"   >
                    <div class="carousel-inner  vertical" >
                        <div class="carousel-item active  vertical" style="max-height: 40px" data-interval="2000">
                            <a class=" float-right"
                                style="float:right; text-align:right;font-size:34px; font-weight: bolder; font-family:monospace; color: rgb(255, 255, 255); ">{{totalappointmentsquare}}</a>
                        </div>
                      
                    </div>

                   
   
                </div>

                <div class="d-flex  mt-3 mb-0 pt-2 pl-3 p-0 "
                    style="font-size:20px; font-family:Trebuchet MS; font-weight: bolder; color: rgb(184, 184, 184);" translate>
                    Total Appointments </div>
            </div>
        </div>


        
        <a class="carousel-control-prev" href="#appointmentSlide" data-slide="prev" hidden>
            <span class="carousel-control-prev-icon"></span>
        </a>
        <a class="carousel-control-next" href="#appointmentSlide" data-slide="next" hidden>
            <span class="carousel-control-next-icon"></span>
        </a>
    </div>
-->
<!---------------------------------------------------------------------------------------------------------------------------------------------------------------------------->
<!--

    <div class="col-sm-3 ">
        <div class="row border p-1 m-1  border-black rounded   " style="background:#003b76;">
            <i class="col-md-3 fa fa-store-alt fa-5x p-2" style="color:#00000060;"></i>



            <div class="col-sm-9 p-0  w-100">

                <div id="trioSlide1" class="carousel slide vertical  h-100 " data-ride="carousel"   >
                    <div class="carousel-inner vertical h-100"  >

                        
                        <div class="carousel-item vertical h-100 " data-interval="2000" >
                            <a class=" d-flex p-0 m-0 d-flex"
                                style="float:right; font-size: 35px; font-family:monospace; font-weight: bolder; color:rgb(255, 255, 255);">
                                <p>{{janerequesttypeforbranchsquare}}</p>
                            </a>

                            <a translate class= "d-flex align-items-end h-100 pb-1" style="font-size:20px; font-family:Trebuchet MS; padding-left: 35px; font-weight: bolder; color: rgb(184, 184, 184);">
                                8899 Jane St</a>
                        </div>

                        <div class="carousel-item vertical h-100 " data-interval="2000" >
                            <a class=" d-flex p-0 m-0 d-flex"
                                style="float:right; font-size: 35px; font-family:monospace; font-weight: bolder; color: rgb(255, 255, 255);">
                                <p>{{lawrencerequesttypeforbranchsquare}}</p>
                            </a>

                            <a translate class= "d-flex align-items-end h-100 pb-1" style="font-size:20px; font-family:Trebuchet MS; padding-left: 35px; font-weight: bolder; color: rgb(184, 184, 184);">
                                1020 Lawrence</a>
                        </div>


                        <div class="carousel-item active vertical h-100" data-interval="2000" >
                            <a class="d-flex  p-0 m-0"
                                style="float:right; text-align:right;font-size:35px; font-family:monospace; font-weight: bolder; color: rgb(255, 255, 255); ">{{vegarequesttypeforbranchsquare}}</a>

                               <a translate class= "d-flex align-items-end h-100 pb-1"  style="font-size:20px; font-family:Trebuchet MS; padding-left: 35px; font-weight: bolder; color: rgb(184, 184, 184);">
                                3050 Vega</a>

                                
                        </div>
                 


                        <div class="carousel-item  vertical h-100" data-interval="2000" >
                            <a class="d-flex  p-0 m-0"
                                style="float:right; text-align:right;font-size:35px; font-family:monospace; font-weight: bolder; color: rgb(255, 255, 255); ">{{stlaurentrequesttypeforbranchsquare}}</a>

                               <a translate class= "d-flex align-items-end h-100 pb-1"  style="font-size:20px; font-family:Trebuchet MS; padding-left: 35px; font-weight: bolder; color: rgb(184, 184, 184);">
                                9151 St Laurent</a>

                                
                        </div>


                    </div>
                </div>

          


                <a class="carousel-control-prev" href="#trioSlide1" data-slide="prev" hidden>
                    <span class="carousel-control-prev-icon"></span>
                </a>
                <a class="carousel-control-next" href="#trioSlide1" data-slide="next" hidden>
                    <span class="carousel-control-next-icon"></span>
                </a>
            </div>
        </div>

    </div>
-->
<!------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------->

    <!--   <div class="col-sm-3 ">
        <div class="row border p-1 m-1 bg-primary border-primary rounded   ">
       <i class="col-md-3 fa fa-users fa-5x p-2"  style="color:#003366;"></i>
       <div class="col-sm-5 mt-5 pt-2 "  style="font-size:34px; font-family:Trebuchet MS; font-weight: bolder; color: whitesmoke;"> Employees</div>
       <div class="col-sm-4">
         <a class="text-lg" style="float:right; font-size: 50px;">{{employees.length}}</a>
        </div>
    </div>
    </div>-->




   <!-- <div class="col-sm-3 ">
        <div class="row border border-black p-1 m-1  rounded   "  style="background:#003b76;">
            <i class="col-md-3 fa fa-trophy fa-5x p-2" style="color:#00000060"></i>



            <div class="col-sm-9 p-0 w-100">

                <div id="employeeSlide" class="carousel slide vertical  h-100 " data-ride="carousel"   >
                    <div class="carousel-inner vertical h-100" >
                        <div class="carousel-item active vertical h-100" data-interval="2000" >
                            <div class="d-flex flex-column">
                            <a class=" p-0 m-0"
                                style="float:right; text-align:right;font-size:25px; font-family:monospace; font-weight: bolder;color: rgb(255, 255, 255); ">
                                {{populardescribesyousquarekey}}</a><br>


                                <div class="d-flex">
                                    <a translate class= " align-items-end h-100 pb-1"  style="font-size:20px; font-family:Trebuchet MS; padding-left: 15px; font-weight: bolder; color: rgb(184, 184, 184);">
                                        Popular Client</a>

                                <a class=" p-0 m-0 mt-3"
                                style="float:right; text-align:right;font-size:25px; font-family:monospace;font-weight: bolder; color: rgb(255, 255, 255); ">{{populardescribesyousquarevalue}}</a><br>
                            </div>
                            </div>

                                
                        </div>
                        <div class="carousel-item vertical h-100  " data-interval="2000" >
                            <div class="d-flex flex-column">
                                <a class=" p-0 m-0"
                                    style="float:right; text-align:right;font-size:25px; font-family:monospace; font-weight: bolder;color: rgb(255, 255, 255); ">
                                    {{popularlookingforsquarekey}}</a><br>
    
    
                                    <div class="d-flex">
                                        <a translate class= " align-items-end h-100 pb-1"  style="font-size:20px; font-family:Trebuchet MS; padding-left: 15px; font-weight: bolder; color: rgb(184, 184, 184);">
                                            Popular Product</a>
    
                                    <a class=" p-0 m-0 mt-3"
                                    style="float:right; text-align:right;font-size:25px; font-family:monospace;font-weight: bolder; color: rgb(255, 255, 255); ">{{popularlookingforsquarevalue}}</a><br>
                                </div>
                                </div>
                        </div>
                    </div>
                </div>


                <a class="carousel-control-prev" href="#employeeSlide" data-slide="prev" hidden>
                    <span class="carousel-control-prev-icon"></span>
                </a>
                <a class="carousel-control-next" href="#employeeSlide" data-slide="next" hidden>
                    <span class="carousel-control-next-icon"></span>
                </a>

            </div>
        </div>

    </div>
-->
<!--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------->            
  <!--  <div class="col-sm-3 ">
        <div class="row border p-1 m-1  border-black rounded   " style="background:#003b76;" >
            <i class="col-md-3 fa fa-user-tie fa-5x p-2" style="color:#00000060;"></i>
            <div class="col-sm-5 mt-4 pt-3 " translate
                style="font-size:20px; font-family:Trebuchet MS; font-weight: bolder; font-weight: bolder; color: rgb(184, 184, 184);">
                Sales Representative</div>
            <div class="col-sm-4">
                <a class=" float-right text-white" style="float:right;  font-weight: bolder;  text-align:right; font-family:monospace; font-size:35px;">{{totalsalesrepsquare}}</a>
               
            </div>
        </div>
    </div>
</div>




</div>
-->
<!--*********************************************************************************************************************************************************************************************************************************-->
<!--<div class="col-md-12 d-flex  "   >
  <div class=" col-md-12  mt-2 box box-primary rounded border-top border-primary shadow-sm bg-white p-1  pb-5"style="min-width: 28%; "  >
        <div id="salesrepSlide" class="carousel slide " data-ride="carousel" >

          
            <ul class="carousel-indicators">
                <li data-target="#salesrepSlide" data-slide-to="0" class="active"></li>
                <li data-target="#salesrepSlide" data-slide-to="1"></li>
                <li data-target="#salesrepSlide" data-slide-to="2"></li>
            </ul>

           
            <div class="carousel-inner">
                <div class="carousel-item active">
                    <div class=" border p-3 m-1 rounded   " >
                        <h6 class="table-heading rounded text-white text-center p-3 " style="background-color: #003b76;" ><strong translate>Sales Representative Appointments</strong>   <div class="p-1 mr-3">
                  
                 </div></h6>
                        
                <div  style="overflow:auto; overflow-y: scroll; z-index: none; max-height: 220px;"  >
                    <table class="table w-100  text-center"  style="font-size: 12px; max-height: 100px;">
                                
                       
                        <th class="text-center p-2" style=" font-family:'DINPro'" translate>Full Name</th>

                        <th class="text-center p-2" style=" font-family:'DINPro'" translate>Count</th>
                        <th class="text-center p-2" style=" font-family:'DINPro'" translate>Location</th>
                       
                       
                       
                        <tr   *ngFor='let list of allsalesrepapt' style=" font-family:'DINPro'">
                            <td class="text-center p-2"   >{{list.salesRep}}</td>                           
                            <td class="text-center p-2"  >{{list.count}}</td>
                            <td class="text-center p-2"  >{{list.branch}}</td>
                        </tr>

                    </table>
               </div>
                    </div>
                </div>

            
            
            </div>

          
        </div>
      
</div>

 

</div>






<div class="col-md-12  "   >

    <h6 class="table-heading rounded text-white text-center p-3 " style="background-color: #003b76;" ><strong translate>Appointments Per Month</strong>   </h6>
    <div class="row w-100 d-flex ">

        <div class="col-md-4  mt-5 chart-container  box box-primary rounded border-top border-primary shadow-sm bg-white p-3  " >

            <canvas class="col-md-5" id="JaneChart" style="max-width:100%; min-width: 100%;" ></canvas>
        </div>

        
   <div class="col-md-4  mt-5 chart-container  box box-primary rounded border-top border-primary shadow-sm bg-white p-3  "  >

   <canvas class="col-md-5" id="VegaChart" style="max-width:100%; min-width: 100%;" ></canvas>
</div>



 <div class="col-md-4  mt-5 chart-container  box box-primary rounded border-top border-primary shadow-sm bg-white p-3  " >

    <canvas class="col-md-5" id="LawrenceChart" style="max-width:100%; min-width: 100%;" ></canvas>
 </div>



 


 </div>
</div>











<div class="col-md-12 d-flex w-100" [formGroup]="halfdonutForm" >
    
   <div class=" d-flex flex-column col-md-3 box box-primary border-top border-primary shadow-sm bg-white my-3 p-3"
   style="max-width:100%; min-width: 33%; ">
   <div class="text-center p-2">
   <select (change)="switchhalfdonutlookingFormonth($event.target.value)"  formControlName="halfdonutlookingFor" style=" font-family:'DINPro'" class="form-control" >
    <option value="January">January</option>
    <option value="February">February</option>
    <option value="March">March</option>
    <option value="April">April</option>
    <option value="May">May</option>
    <option value="June">June</option>
    <option value="July">July</option>
    <option value="August">August</option>
    <option value="September">September</option>
    <option value="October">October</option>
    <option value="November">November</option>
    <option value="December">December</option>
</select>
</div>
   <div class="chart-container "  >
 
       <canvas id="productinquiryhalfdonut"></canvas>
   </div>


   
 </div>


 <div class=" d-flex flex-column col-md-3 box box-primary border-top border-primary shadow-sm bg-white my-3 p-3"
   style="max-width:100%; min-width: 33%; ">
   <div class="text-center p-2">
   <select (change)="switchhalfdonutdescribesYoumonth($event.target.value)" formControlName="halfdonutdescribesYou"style=" font-family:'DINPro'" class="form-control text-center">
    <option value="January">January</option>
    <option value="February">February</option>
    <option value="March">March</option>
    <option value="April">April</option>
    <option value="May">May</option>
    <option value="June">June</option>
    <option value="July">July</option>
    <option value="August">August</option>
    <option value="September">September</option>
    <option value="October">October</option>
    <option value="November">November</option>
    <option value="December">December</option>
</select>
</div>
   <div class="chart-container "  >
 
       <canvas id="describesyouhalfdonut"></canvas>
   </div>


   
 </div>



 <div class=" d-flex flex-column col-md-3 box box-primary border-top border-primary shadow-sm bg-white my-3 p-3"
 style="max-width:100%; min-width: 33%; ">
 <div class="text-center p-2">
 <select (change)="switchhalfdonutrequestTypemonth($event.target.value)" formControlName="halfdonutrequestType" style=" font-family:'DINPro'" class="form-control text-center">
  <option value="January">January</option>
  <option value="February">February</option>
  <option value="March">March</option>
  <option value="April">April</option>
  <option value="May">May</option>
  <option value="June">June</option>
  <option value="July">July</option>
  <option value="August">August</option>
  <option value="September">September</option>
  <option value="October">October</option>
  <option value="November">November</option>
  <option value="December">December</option>
</select>
</div>
 <div class="chart-container "  >

     <canvas id="requesttypehalfdonut"></canvas>
 </div>


 
</div>

       



        </div>







        <div class="col-md-12 text-center" >
            <div class="row d-flex justify-content-between w-100 m-0">
                <div class=" d-flex flex-column col-md-3 box box-primary border-top border-primary shadow-sm bg-white my-3 p-3"
                style="max-width:100%; min-width: 32%; ">
                <div class="chart-container "  >
            <canvas id="lookingForcanvas" ></canvas>
            </div>



            <div class=" col-md-12 mt-5 box box-primary rounded border-top border-primary shadow-sm bg-white p-1  pb-5"style="min-width: 28%; "  >
                <div id="productSlide" class="carousel slide " data-ride="carousel">
        
                
                    <ul class="carousel-indicators">
                        <li data-target="productSlide" data-slide-to="0" class="active"></li>
                        <li data-target="#productSlide" data-slide-to="1"></li>
                        <li data-target="#productSlide" data-slide-to="2"></li>
                    </ul>
        
                   
                    <div class="carousel-inner">
                        <div class="carousel-item active">
                            <div class=" border p-3 m-1 rounded   " >
                          
                                
                        <div  style="overflow:auto; overflow-y: scroll; z-index: none; max-height: 220px;"  >
                            <table class="table w-100  text-center"  style="font-size: 12px; max-height: 100px;">

                                      
                                <th class=" p-2 text-success" style=" font-family:'DINPro'" translate>Product</th>
                                <th class="text-center p-2 text-success" style=" font-family:'DINPro'">#</th>
                               

                                <tr   *ngFor='let list of lookingforapt | keyvalue '>
                                    <td class="p-2 text-success"  style=" font-family:'DINPro'" >{{list.key}}</td>                           
                                    <td class="text-center p-2 text-success" style=" font-family:'DINPro'" >{{list.value}}</td>
                                </tr>
        
                            </table>




                       </div>
                            </div>
                        </div>
                        
                    </div>
        
              
                </div>
              
        </div>
           </div> 


           <div class=" d-flex flex-column col-md-3 box box-primary border-top border-primary shadow-sm bg-white my-3 p-3"
           style="max-width:100%; min-width: 32%; ">

           <div class="chart-container "  >
            <canvas id="describesYoucanvas" ></canvas>
            </div>


            <div class="  mt-5 box box-primary rounded border-top border-primary shadow-sm bg-white p-1  pb-5"style="min-width: 28%; "  >
                <div id="clientSlide" class="carousel slide " data-ride="carousel">
        
                   
                    <ul class="carousel-indicators">
                        <li data-target="#clientSlide" data-slide-to="0" class="active"></li>
                        <li data-target="#clientSlide" data-slide-to="1"></li>
                        <li data-target="#clientSlide" data-slide-to="2"></li>
                    </ul>
        
                   
                    <div class="carousel-inner">
                        <div class="carousel-item active">
                            <div class=" border p-3 m-1 rounded   " >
                          
                                
                        <div  style="overflow:auto; overflow-y: scroll; z-index: none; max-height: 220px;"  >
                            <table class="table w-100  text-center"  style="font-size: 12px; max-height: 100px;">
                                        
                               
                                <th class=" p-2 text-primary" style=" font-family:'DINPro'" translate>Clients</th>
                                <th class="text-center p-2 text-primary" style=" font-family:'DINPro'">#</th>
                               
                               
                               
                                <tr   *ngFor='let list of describesyouapt | keyvalue '>
                                    <td class="p-2 text-primary" style=" font-family:'DINPro'"  >{{list.key}}</td>                           
                                    <td class="text-center p-2 text-primary" style=" font-family:'DINPro'" >{{list.value}}</td>
                                </tr>
        
                            </table>
                       </div>
                            </div>
                        </div>
                        
                    </div>
        
              
                </div>
              
        </div>
           </div> 


           <div class=" d-flex flex-column col-md-3 box box-primary border-top border-primary shadow-sm bg-white my-3 p-3"
           style="max-width:100%; min-width: 31%; ">
           <div class="chart-container "  >
            
            <canvas id="requestTypecanvas" ></canvas>
            
            </div>






            <div class="  mt-5 box box-primary rounded border-top border-primary shadow-sm bg-white p-1  pb-5"style="min-width: 28%; "  >
                <div id="typeSlide" class="carousel slide " data-ride="carousel">
       
                  
                    <ul class="carousel-indicators">
                        <li data-target="#typeSlide" data-slide-to="0" class="active"></li>
                        <li data-target="#typeSlide" data-slide-to="1"></li>
                        <li data-target="#typeSlide" data-slide-to="2"></li>
                    </ul>
        
                   
                    <div class="carousel-inner">
                        <div class="carousel-item active">
                            <div class=" border p-3 m-1 rounded   " >
                          
                                
                        <div  style="overflow:auto; overflow-y: scroll; z-index: none; max-height: 220px;"  >
                            <table class="table w-100  text-center"  style="font-size: 12px; max-height: 100px;">
                                        
                               
                                <th class=" p-2 text-danger" style=" font-family:'DINPro'" translate>Type</th>
                                <th class="text-center p-2 text-danger" style=" font-family:'DINPro'">#</th>
                               
                               
                               
                                <tr   *ngFor='let list of requesttypeapt | keyvalue '>
                                    <td class="p-2 text-danger" style=" font-family:'DINPro'"  >{{list.key}}</td>                           
                                    <td class="text-center p-2 text-danger" style=" font-family:'DINPro'" >{{list.value}}</td>
                                </tr>
        
                            </table>
                       </div>
                            </div>
                        </div>
                        
                    </div>
        
              
                </div>
              
        </div>


           </div> 
</div>

        </div>








        <div class="col-md-12 bg-muted p-0 mb-0 " style="min-height: 10%;">
            <div class=" d-flex justify-content-between row w-85 mt-2 mx-3">
            
          <div class=" col-md-12 box box-primary rounded border-top border-primary shadow-sm bg-white p-1 " style="min-width: 48%;"  >
                <div id="notificationSlide" class="carousel slide " data-ride="carousel">
        
                   
                    <ul class="carousel-indicators">
                        <li data-target="#notificationSlide" data-slide-to="0" class="active"></li>
                        <li data-target="#notificationSlide" data-slide-to="1"></li>
                        <li data-target="#notificationSlide" data-slide-to="2"></li>
                    </ul>
        
                    
                    <div class="carousel-inner" >
                        <div class="carousel-item active">
                            <div class=" border p-3 m-1 rounded   " >
                                <h6 class="table-heading rounded text-white text-center p-3" style="background-color: #035332; font-family:'DINPro'"><strong translate>Client's Interest</strong></h6>
                        <div  style="overflow:auto; height: 200px;"  >
                            <table class="table w-100 text-center"  style=" font-size: 12px;" >
                                <thead >
                                    <tr >
                                     <th  *ngFor='let table of tablelookingforarray[0] | keyvalue ' class=" p-2" style=" font-family:'DINPro'" >{{table.key}}</th>
                                 </tr>
                                 </thead>
                                 <tbody class="pt-4" style="overflow:auto;">
                                     <tr *ngFor='let tableData of tablelookingforarray '>
                                      
                                         <td *ngFor='let table of tableData | keyvalue'  >
                                            <ng-container class="font-weight-bold float-left" *ngIf="table.value=='Average' || table.value=='8899 Jane St' || table.value=='3050 Vega'  || table.value=='1020 Lawrence' || table.value=='9151 St Laurent' || table.value=='5302 2nd Ave';  else elseBlock" style="font-weight: bolder;">      
                                            <div class="font-weight-bold float-left" style="font-size: 15px; font-family:'DINPro'">{{table.value}}</div>
                                        </ng-container>
                                        <ng-template #elseBlock>{{table.value}}</ng-template>
                                    </td>
                                        
                                        
                                    
                                     </tr>
                                 </tbody>
                                 </table>
                       </div>
                            </div>
                        </div>
        
                       <div class="carousel-item ">
                            <div class=" border p-3 m-1 rounded  " >
                                <h6 class="table-heading   rounded text-white bg-primary text-center p-3" style=" font-family:'DINPro'"><strong translate>Client's Category</strong></h6>
                           
                                <div  style=" height: 200px; overflow:auto;"  >
                                    <table class="table w-100 text-center"  style=" font-size: 12px; font-family:'DINPro'" >
                                   <thead >
                                       <tr >
                                        <th  *ngFor='let table of tabledescribesYouarray[0] | keyvalue ' class=" p-2" style=" font-family:'DINPro'" >{{table.key}}</th>
                                    </tr>
                                    </thead>
                                    <tbody class="pt-4" style="overflow:auto;">
                                        <tr *ngFor='let tableData of tabledescribesYouarray '>
                                            <td *ngFor='let table of tableData | keyvalue' >
                                                <ng-container class="font-weight-bold float-left" *ngIf="table.value=='Average' || table.value=='8899 Jane St' || table.value=='3050 Vega'  || table.value=='1020 Lawrence' || table.value=='9151 St Laurent';  else elseBlock" style="font-weight: bolder;">      
                                                    <div class="font-weight-bold float-left" style="font-size: 15px; font-family:'DINPro'">{{table.value}}</div>
                                                </ng-container>
                                                <ng-template #elseBlock>{{table.value}}</ng-template>
                                            </td>
                                   
                                           
                                           
                                       
                                        </tr>
                                    </tbody>
                                    </table>
                                        
                                </div>
                        </div>
                        </div>
                       <div class="carousel-item " >
                            <div class=" border p-3 m-1 rounded   " >
                                <h6 class="table-heading rounded text-center text-white p-3" style="background-color:#c32525;  font-family:'DINPro'"><strong translate>Request Categories</strong></h6>
                                <div   style="overflow:auto; height: 200px;"  >
                                    <table class="table w-100 text-center"  style=" font-size: 12px;" >
                                        <thead >
                                            <tr >
                                             <th  *ngFor='let table of tablerequestTypearray[0] | keyvalue ' class=" p-2" style=" font-family:'DINPro'" >{{table.key}}</th>
                                         </tr>
                                         </thead>
                                         <tbody class="pt-4" style="overflow:auto;">
                                             <tr *ngFor='let tableData of tablerequestTypearray '>
                                                 <td *ngFor='let table of tableData | keyvalue' >
                                                    <ng-container class="font-weight-bold float-left" *ngIf="table.value=='Average' || table.value=='8899 Jane St' || table.value=='3050 Vega'  || table.value=='1020 Lawrence' || table.value=='9151 St Laurent';  else elseBlock" style="font-weight: bolder;">      
                                                        <div class="font-weight-bold float-left" style="font-size: 15px; font-family:'DINPro'">{{table.value}}</div>
                                                    </ng-container>
                                                    <ng-template #elseBlock>{{table.value}}</ng-template>

                                                 </td>
                                        
                                                
                                                
                                            
                                             </tr>
                                         </tbody>
                                         </table>
                                </div>
                        </div>
                        </div>
                    </div>
        
                   
                    <a class="carousel-control-prev" href="#notificationSlide" role="button" data-slide="prev">
                        <span class="carousel-control-prev-icon"></span>
                    </a>
                    <a class="carousel-control-next" href="#notificationSlide" role="button" data-slide="next">
                        <span class="carousel-control-next-icon"></span>
                    </a>
                </div>
              
        </div>
        </div>
        </div>



        <div class="col-md-12 my-3   " >
            <div class="col-md-12  chart-container  box box-primary rounded border-top border-primary shadow-sm bg-white p-3  " style="max-width:100%; min-width: 100%; ;" >
            
                <canvas class="col-md-12" style="max-height: 500px" id="myCharta" ></canvas>
             </div>
            </div>

            
        <div class="col-md-12 d-flex" >
      
           </div>
        -->